module.exports = __webpack_public_path__ + "81d9f651a93714611193d98ec5b2d2fd.svg";